import * as ReselectModule from "reselect";
import { IDefaultDocumentDocumentListState } from ".";
import { IApplicationState } from "..";

export const selectDefaultDocumentDocumentList: ReselectModule.Selector<
  IApplicationState,
  IDefaultDocumentDocumentListState
> = (state) => state.defaultDocumentDocumentList;
